<template>
    <div class="head">
        <div class="left-timer">{{ timer }}</div>
        <div class="head-title">
            <img src="../../assets/template3/header-left.png" alt="" class="left-icon">
            {{ title }}
            <img src="../../assets/template3/header-right.png" alt="" class="right-icon"> 
        </div>

        <div class="large" @click="screen">
            <img src="../../assets/template/screen.png" alt="">
            全屏
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'

export default {
    name: 'template.temhead2',
    props: {
        title: {
            type: String,
            default: '数字乡村一张图大屏'
            // default: '大屏'
        }
    },
    data() {
        return {
            timer: ''
        }
    },
    mounted() {
        this.gettime()
    },
    methods: {
        gettime() {
            this.timer = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        screen() {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
                // this.$message("您的浏览器不能全屏")
                return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 134px;
    background: url(../../assets/template3/header.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 401;
    pointer-events: none;
    margin-bottom: 21px;

    .head-title {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 40px;
        color: #FFFFFF;
        line-height: 40px;
        // text-shadow: 0px 1px 6px rgba(0,0,0,0.48);
        height: fit-content;
        padding: 8px;
        margin-top: -40px;
        position: relative;
    }

    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #BBFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 50px;
    }

    .large {
        position: absolute;
        right: 64px;
        top: 42px;
        cursor: pointer;
        pointer-events: auto;
        font-size: 18px;

        img {
            width: 46px;
            height: 46px;
        }
    }
}

.left-icon {
    position: absolute;
    width: 46px;
    height: 37px;
    left: -100px;
    top: calc(50% - 18px);
    animation: leftani 3s infinite;
}

.right-icon {
    position: absolute;
    width: 46px;
    height: 37px;
    right: -108px;
    top: calc(50% - 18px);
    animation: rightani 3s infinite;
}

@keyframes leftani {
    0% {
        transform: translateX(0px);
        opacity: 1;
    }

    50% {
        transform: translateX(-10px);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes rightani {
    0% {
        transform: translateX(0px);
        opacity: 1;
    }

    50% {
        transform: translateX(10px);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>